<mat-card class="mat-card-top notes-app cardWithShadow overflow-hidden">
  <mat-sidenav-container
    [ngClass]="{
      'side-panel-opened': sidePanelOpened(),
      'side-panel-closed': !sidePanelOpened()
    }"
    class="h-100"
  >
    <mat-sidenav
      #noteslist
      [mode]="isOver() ? 'over' : 'side'"
      [opened]="!isOver()"
      (open)="sidePanelOpened.set(true)"
      (close)="sidePanelOpened.set(false)"
      style="width: 290px"
    >
      <div class="p-16">
        <mat-form-field appearance="outline" class="w-100 hide-hint">
          <input
            matInput
            type="text"
            (keyup)="applyFilter($event)"
            placeholder="Search Notes"
          />
          <mat-icon matSuffix>
            <i-tabler name="search" class="icon-20 d-flex m-t-2"></i-tabler>
          </mat-icon>
        </mat-form-field>
      </div>
      <ng-scrollbar
        class="position-relative"
        style="height: calc(100vh - 400px)"
      >
        <h4 class=" f-s-16 f-w-600 p-x-16 m-t-16">All Notes</h4>

        <mat-nav-list class="p-x-16">
          @if(notes().length > 0) { @for(note of notes(); track note.datef) {
          <mat-list-item
            class="notes-item rounded m-b-8 bg-light-{{ note.color }}"
            (click)="onSelect(note)"
            [class.selected]="note === selectedNote()"
          >
            <span
              class="note-title  f-w-500 text-{{ note.color }}"
              matListItemTitle
              >{{ note.title }}</span
            >
            <div class="d-flex justify-content-between">
              <span class="note-time f-s-12 f-w-500">{{
                note.datef | date
              }}</span>
              <span
                (click)="removenote(note); $event.stopPropagation()"
                class="remove-note"
                matTooltip="Delete"
              >
                <i-tabler name="trash" class="icon-16"></i-tabler>
              </span>
            </div>
          </mat-list-item>
          } } @else {
          <div
            class="p-15 bg-light-primary text-primary rounded m-t-20 text-center"
          >
            <span class="m-0 f-s-14">No Notes Found</span>
          </div>
          }
        </mat-nav-list>
      </ng-scrollbar>
    </mat-sidenav>
    <mat-toolbar class="b-b-1">
      <div class="d-flex align-items-center justify-content-between w-100">
        <button (click)="noteslist.toggle()" class="d-flex" mat-icon-button>
          <i-tabler name="menu-2" class="icon-20"></i-tabler>
        </button>
        <button mat-flat-button (click)="addNoteClick()">Add Notes</button>
      </div>
    </mat-toolbar>
    <ng-scrollbar class="position-relative" style="height: calc(100vh - 370px)">
      <mat-card-content>
        @if(selectedNote()){
        <div>
          <h4 class="f-s-16 f-w-600 m-b-16">Edit Note</h4>
          <mat-form-field appearance="outline" class="w-100">
            <textarea
              matInput
              [ngModel]="selectedNote()?.title"
              rows="5"
              class="note-content p-8"
              (ngModelChange)="updateNoteTitle($event)"
            ></textarea>
          </mat-form-field>
          <h4 class="f-s-16 f-w-600 m-b-16">Change Note Color</h4>
          <div class="d-flex align-items-center">
            @for(c of colors; track c.colorName) {
            <div class="Selectbuttoncolor">
              <button
                mat-mini-fab
                class=" bg-{{ c.colorName }} rounded-circle icon-21 m-r-8"
                (click)="onSelectColor(c.colorName)"
                [ngClass]="{
                  selectColorResizable: selectedColor() === c.colorName
                }"
              ></button>
              @if(selectedColor() === c.colorName) {
              <div>
                <mat-icon class="checkIcon">check</mat-icon>
              </div>
              }
            </div>
            }
          </div>
        </div>
        } @else{

        <div
          class="d-flex align-items-center justify-content-center h-100 w-100"
        >
          <div>
            <img src="/assets/images/breadcrumb/emailSv.png" width="250px" />
            <h3 class="f-s-21 f-w-600 text-center m-t-20">No note selected</h3>
          </div>
        </div>
        }
      </mat-card-content>
    </ng-scrollbar>
  </mat-sidenav-container>
</mat-card>
